export default "__VITE_ASSET__eUZgsG0S__"